







































	import { Vue, Component, PrepareTranslate, Watch } from "../../Infrastructure/CorBase/CoreBase";
	import TopMenuLight from "../../Components/TopMenuLight.vue";
	import * as PageDefinition from "../../Infrastructure/PageDefinition";
	@Component({
		components: {
			"top-menu-light": TopMenuLight
		}
	})
	export default class App extends Vue {
		showMenu: boolean = this.showMenuByParams();
		prepareTranslate = new PrepareTranslate();

		CopyrightYear = PageDefinition.CopyrightYear;

		//TODO do nasazeni do produkce vzdy odkomentovat aby fungovalo CLARITY
		//mounted() {			
  //          // Tato anonymní funkce je IIFE (Immediately Invoked Function Expression),
  //          // která inicializuje Clarity tracking script.
  //          // V TypeScriptu je někdy nutné explicitně deklarovat typy proměnných,
  //          // zvláště pokud TypeScript nemůže odvodit typy implicitně.
  //          (function (c: any, l: Document, a: string, r: string, i: string) {
  //              // Zde definujeme funkci 'clarity' na objektu 'window', pokud již neexistuje.
  //              c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };

  //              // Vytvoříme nový skriptový element.
  //              let t = l.createElement(r) as HTMLScriptElement;
  //              t.async = true;

  //              // Nastavíme zdroj skriptu na URL Clarity tracking scriptu.
  //              t.src = "https://www.clarity.ms/tag/" + i;

  //              // Najdeme první skriptový tag v dokumentu (pokud existuje) a vložíme nový skript před něj.
  //              let y = l.getElementsByTagName(r)[0];
  //              if (y && y.parentNode) {
  //                  y.parentNode.insertBefore(t, y);
  //              }
  //          })(window, document, 'clarity', 'script', 'gqum4x0995');
  //      }



	

		getVersionNumber() {
			//this.versionNumber = "";
			return this.$t('global.version').toString() + " " + this.$store.state.versionNumber;
		}

		created() {
			//tady je potreba nacist znovlu ty navic jazyky, jinak po refreshi jsou vymazány
			if (this.$store.state.isLogged) {
				this.prepareTranslate.addLangByModule(this.$store.state.tenantModules, this.$store.state.tenantLanguages, this.$i18n);
			}
		}

		@Watch('$i18n.locale')
		changeFieldsAfterChangeLanguage(value: boolean, oldValue: boolean) {
			if (value !== oldValue) {
				this.$forceUpdate();
			}
		}

		/**skrytí menu - pro plachtu která je samostatně */
		updateStatus() {
			//this.showMenu = false;
		}


		showMenuByParams(): boolean {
			//let aloneWindow = this.$route.params.aloneWindow;
			let aloneWindow = this.$router.currentRoute.query.aloneWindow;
			return aloneWindow != 'true';
		}

		showTruslab() {
			let routeName = this.$router.currentRoute.name;
			return routeName != PageDefinition.PAGE_Login;
		}

		initPage: string = '';
		getStyle() {
			let routeName = this.$router.currentRoute.name;
			if (routeName == PageDefinition.PAGE_Login) {
				this.initPage = 'login';
				//return 'background-color: var(--color-red-main-grey);';
				return 'background-color: white;';
			}
			else {
				this.initPage = '';
			}
			return 'padding-bottom: 15px;';
		}
	}
